// 直播企微引流到小程序中转页面
<template>
  <div class="page">
    <div class="container" v-if="status != 1">
      <div class="tabs" v-if="!isOnlyRoleId">
        <span @click="type = 0" :class="[type == 0 ? 'acc' : '']"
          >手机号确认</span
        >
        <span @click="type = 1" :class="[type == 1 ? 'acc' : '']"
          >账号确认</span
        >
      </div>
      <!-- 小游戏链接 角色ID绑定 -->
      <div class="tabs" v-if="isOnlyRoleId">
        <span class="acc">角色ID确认</span>
      </div>

      <div v-if="!isOnlyRoleId" :class="['main', type == 1 ? 'acc' : '']">
        <input
          v-if="type == 0"
          placeholder="请输入登录游戏时的11位手机号"
          type="number"
          v-model.trim="phone"
        />
        <input
          v-if="type == 1"
          placeholder="请输入登录游戏时的账号"
          type="text"
          v-model.trim="username"
        />
        <button class="btn" @click="getUserInfo()">确认</button>
      </div>

      <div v-if="isOnlyRoleId" :class="['main', 'minigame-main']">
        <input
          v-if="type == 0"
          placeholder="请输入登录游戏的角色ID"
          type="number"
          v-model.trim="role_id"
        />
        <button class="btn" @click="getUserInfo()">确认</button>
      </div>
    </div>
    <img :src="background" alt="" class="back-img" v-if="background" />
    <div class="back" v-if="status == 1">
      <img :src="qy_qr_code" alt="" class="qrcode" v-if="qy_qr_code" />
    </div>
  </div>
</template>

<script>
import { getLiveQWCode, eventTrackExtra } from "@/apis/gameJump";

export default {
  data() {
    return {
      type: 0, // 0: 手机号绑定，1: 账号绑定
      phone: "",
      username: "",
      user_id: "",
      appkey: "",
      qy_qr_code: "",
      status: 0,
      background: "",
      isOnlyRoleId: false, // 是否是小游戏的链接 小游戏链接只展示角色ID绑定
      role_id: '', // 角色ID
    };
  },
  async mounted() {
    this.buryReport("QY_WEIXIN_STREAM_SHOW", {
      config_id: atob(this.$route.query.id || ''), // 配置ID
    });
    this.isOnlyRoleId = this.$route.query.isOnlyRoleId || false
    this.getUserInfo(1);
  },
  methods: {
    // type: 1: 页面打开判断链接是否有效 0: 绑定用户信息
    async getUserInfo(type) {
      const { stream_gu, id } = this.$route.query;

      // 辅助函数，用于统一处理 buryReport 的调用
      const report = (value, result, bindType) => {
        this.buryReport("QY_WEIXIN_STREAM_BIND", {
          config_id: atob(id || ''), // 配置ID
          type: bindType, // 手机号绑定、账号绑定
          value: value, // 手机号/账号
          result: result, // 报错提示/单人单码
        });
      };
      try {
        let params = { stream_gu };

        // 检查 type 是否为空，如果为空，检查手机号或用户名
        if (!type) {
          if  (this.isOnlyRoleId) {
            // 角色ID绑定流程
            if (!this.role_id) {
              this.$toast("请输入角色ID");
              report("", "请输入角色ID", "角色ID绑定");
              return;
            }
            params.role_id = this.role_id;
          } else {
            if (this.type === 0) {
              // 手机号绑定流程
              if (!this.phone) {
                this.$toast("请输入手机号");
                report("", "请输入手机号", "手机号绑定");
                return;
              }
              params.tel_num = this.phone;
            } else {
              // 账号绑定流程
              if (!this.username) {
                this.$toast("请输入账号");
                report("", "请输入账号", "账号绑定");
                return;
              }
              params.user_name = this.username;
            }
          }
        }

        const response = await getLiveQWCode(params);

        if (response.ret === 1) {
          const { user_id, appkey, qy_qr_code, status, background } =
            response.content;
          this.user_id = user_id;
          this.appkey = appkey;
          this.qy_qr_code = qy_qr_code;
          this.status = status;
          this.background = background;

          const bindType = this.isOnlyRoleId ? '角色ID绑定' : (params.user_name ? "账号绑定" : "手机号绑定");
          const value = this.isOnlyRoleId ? params.role_id : (params.user_name ? this.username : this.phone);

          if (status === 0) {
            this.$toast("链接已经失效，请联系客服");
            report(value, "链接已经失效，请联系客服", bindType);
          } else if (status === 3 || status === 4) {
            this.$toast("账号输入有误");
            report(value, "账号输入有误", bindType);
          } else if (status === 1) {
            report(value, "单人单码", bindType);
          }
        }
      } catch (error) {
        this.status = 0;
        const bindType = this.isOnlyRoleId ? '角色ID绑定' : (this.user_name ? "账号绑定" : "手机号绑定");
        const value = this.isOnlyRoleId ? this.role_id : (this.user_name ? this.username : this.phone);
        this.$toast("链接已经失效，请联系客服");
        report(value, "链接已经失效，请联系客服", bindType);
        console.error("Error:", error);
      }
    },
    buryReport(type, extra_data) {
      eventTrackExtra({
        appkey: "0",
        event: type,
        device_id: "null",
        device_name: "null",
        system_version: "null",
        extra_data: JSON.stringify({
          ...extra_data,
        }),
        os: this.isAndroid() ? "android" : "ios",
        client_extra_data: JSON.stringify({
          os: this.isAndroid() ? "android" : "ios",
          jh_channel: "null",
        }),
      });
    },
    isAndroid() {
      let u = navigator.userAgent;
      return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    },
    // redirect() {
    //   const appid = 'wx7ebd52bd136e97d9';
    //   let data = encodeURIComponent(`user_id=${this.user_id}&appkey=${this.$route.query.appkey}&qy_qr_code=${this.qy_qr_code}`);
    //   const ENV_VERSION = 'release'; // 正式版为release，体验版为trial，开发版为develop
    //   console.log('data', data);
    //   console.log('ENV_VERSION', ENV_VERSION);
    //   console.log(`weixin://dl/business/?appid=${appid}&path=pages/index/index&query=${data}&env_version=${ENV_VERSION}`);
    //   window.location.href = `weixin://dl/business/?appid=${appid}&path=pages/index/index&query=${data}&env_version=${ENV_VERSION}`
    // }
  },
};
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  height: 100%;
  position: relative;
  .container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 320px;
    height: 300px;
    background: linear-gradient(153deg, #565ade 0%, #658dfd 100%);
    border-radius: 10px;
    overflow: hidden;
    z-index: 100;
  }
  .tabs {
    width: 100%;
    height: 50px;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    > span {
      margin: 0 30px;
      color: #ffffff;
      &.acc {
        font-size: 18px;
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 50px);
    position: relative;
    background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/game_jump/back_1.png")
      no-repeat;
    background-size: 100% 100%;
    padding-top: 80px;
    &.acc {
      background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/game_jump/back_2.png")
        no-repeat;
      background-size: 100% 100%;
    }
    input {
      display: block;
      width: 80%;
      height: 30px;

      margin: auto;
      padding: 0 10px;
      border: none;
      color: #333;
      border-bottom: 1px solid #c6c6c6;
      font-size: 14px;
      &::placeholder {
        color: #a6a6a6;
      }
    }
    .btn {
      width: 134.5px;
      height: 36.5px;
      background: #658dfd;
      border: none;
      border-radius: 18px;
      color: #ffffff;
      font-size: 16px;
      display: block;
      margin: 80px auto 0;
    }
  }
  .minigame-main {
    background: unset;
    background-color: #fff;
  }
  .back-img {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
  .back {
    width: 100%;
    height: 100%;
    z-index: 20;
    position: relative;
    .qrcode {
      position: absolute;
      bottom: 70px;
      right: 40px;
      width: 150px;
      height: 150px;
    }
  }
}
</style>